import React, { useContext } from 'react';
import { AuthContext } from '../../components/AuthWrapper';
import { Navigate, Link } from 'react-router-dom';

const AdminAudioTranscripts = () => {
  const { isAdmin } = useContext(AuthContext);

  // Redirect if not admin
  if (!isAdmin) {
    return <Navigate to="/" />;
  }

  return (
    <div className="container mx-auto py-8 px-4">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold text-navy">Audio Transcripts Management</h1>
        <Link 
          to="/admin"
          className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded"
        >
          Back to Dashboard
        </Link>
      </div>
      
      <div className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-xl font-semibold mb-4">Upload New Audio</h2>
        <p className="text-gray-600">Audio upload functionality coming soon...</p>
      </div>
      
      <div className="mt-8 bg-white rounded-lg shadow-md p-6">
        <h2 className="text-xl font-semibold mb-4">Manage Existing Audio Files</h2>
        <p className="text-gray-600">Audio management functionality coming soon...</p>
      </div>
    </div>
  );
};

export default AdminAudioTranscripts;